import { render, staticRenderFns } from "./FilterUserServicepoints.vue?vue&type=template&id=61110822&scoped=true"
import script from "./FilterUserServicepoints.vue?vue&type=script&lang=ts"
export * from "./FilterUserServicepoints.vue?vue&type=script&lang=ts"
import style0 from "./FilterUserServicepoints.vue?vue&type=style&index=0&id=61110822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61110822",
  null
  
)

export default component.exports